import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import SEO from '../components/Seo';
import Layout from '../components/Layout';
import BookPreview from '../components/BookPreview';

import { H3 } from '../components/StyledComponents/TextStyles';

const BooksListContainer = styled.div``;

const getGutter = (windowWidth) => {
	if (windowWidth <= 1199) {
		return 30;
	} else {
		return 35;
	}
};

const getColumnWidth = (windowWidth) => {
	if (windowWidth <= 479) {
		return 140;
	} else if (windowWidth <= 639) {
		return 170;
	} else if (windowWidth <= 767) {
		return 180;
	} else if (windowWidth <= 1023) {
		return 190;
	} else {
		return 215;
	}
};

const BooksList = ({ books, childItemClass }) => {
	return books.map((book) => {
		return <BookPreview book={book} childItemClass={childItemClass} />;
	});
};

const BookShelf = ({ data, location }) => {
	console.log('DATA', data);
	const siteTitle = data.site.siteMetadata.title;

	const readBooks = data.read.edges;
	const pausedBooks = data.paused.edges;
	const currentlyReadingBooks = data.reading.edges;
	// console.log('READ BOOKS = ', readBooks);
	// console.log('CURRENTLY READING BOOKS = ', currentlyReadingBooks);

	useEffect(() => {
		const Isotope = require('isotope-layout');

		const readingElem = document.querySelector('.reading-list-grid');
		const pausedElem = document.querySelector('.paused-list-grid');
		const readElem = document.querySelector('.read-list-grid');

		const readingIso = new Isotope(readingElem, {
			// options
			itemSelector: '.reading-list-item',
			layoutMode: 'masonry',
			masonry: {
				gutter: getGutter(window.innerWidth),
				fitWidth: true,
				columnWidth: getColumnWidth(window.innerWidth),
			},
		});

		const pausedIso = new Isotope(pausedElem, {
			// options
			itemSelector: '.paused-list-item',
			layoutMode: 'masonry',
			masonry: {
				gutter: getGutter(window.innerWidth),
				fitWidth: true,
				columnWidth: getColumnWidth(window.innerWidth),
			},
		});

		const readIso = new Isotope(readElem, {
			// options
			itemSelector: '.read-list-item',
			layoutMode: 'masonry',
			masonry: {
				gutter: getGutter(window.innerWidth),
				fitWidth: true,
				columnWidth: getColumnWidth(window.innerWidth),
			},
		});

		// * Not required because of gatsby-image plugin
		// * which puts a placeholder base64 image so the layout doesn't change
		// imagesLoaded(elem, (instance) => {
		// 	console.log('all images are loaded');
		// 	iso.layout();
		// });

		window.onresize = () => {
			readingIso.layout();
			pausedIso.layout();
			readIso.layout();
		};
	}, []);

	return (
		<Layout location={location} title={siteTitle}>
			<SEO title="Bookshelf" />
			<div className="books-list-container">
				<H3 customClass="mb-6">Currently Reading</H3>
				<BooksListContainer className="reading-list-grid">
					<BooksList
						books={currentlyReadingBooks}
						childItemClass="reading-list-item"
					/>
				</BooksListContainer>
				<H3 customClass="mb-6">Paused</H3>
				<BooksListContainer className="paused-list-grid">
					<BooksList books={pausedBooks} childItemClass="paused-list-item" />
				</BooksListContainer>
				<H3 customClass="pt-2 mb-6">Read in The Past</H3>
				<BooksListContainer className="read-list-grid">
					<BooksList books={readBooks} childItemClass="read-list-item" />
				</BooksListContainer>
			</div>
		</Layout>
	);
};

export default BookShelf;

export const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				title
			}
		}

		read: allMdx(
			filter: {
				frontmatter: {
					type: { eq: "book" }
					readingStatus: { eq: "read" }
					published: { eq: true }
				}
			}
			sort: { order: DESC, fields: frontmatter___date }
		) {
			edges {
				node {
					body
					frontmatter {
						slug
						date
						title
						author
						published
						cover {
							childImageSharp {
								fluid(maxWidth: 215, quality: 100) {
									...GatsbyImageSharpFluid
								}
							}
						}
						type
						readingStatus
						excerpt
					}
				}
			}
		}

		paused: allMdx(
			filter: {
				frontmatter: {
					type: { eq: "book" }
					readingStatus: { eq: "paused" }
					published: { eq: true }
				}
			}
			sort: { order: DESC, fields: frontmatter___date }
		) {
			edges {
				node {
					body
					frontmatter {
						slug
						date
						title
						author
						published
						cover {
							childImageSharp {
								fluid(maxWidth: 215, quality: 100) {
									...GatsbyImageSharpFluid
								}
							}
						}
						type
						readingStatus
						excerpt
					}
				}
			}
		}

		reading: allMdx(
			filter: {
				frontmatter: {
					type: { eq: "book" }
					published: { eq: true }
					readingStatus: { eq: "reading" }
				}
			}
			sort: { order: DESC, fields: frontmatter___date }
		) {
			edges {
				node {
					body
					frontmatter {
						slug
						date
						title
						author
						published
						cover {
							childImageSharp {
								fluid(maxWidth: 200, quality: 100) {
									...GatsbyImageSharpFluid
								}
							}
						}
						type
						readingStatus
						excerpt
					}
				}
			}
		}
	}
`;
